module.exports = __webpack_public_path__ + "assets/img/pbtrade_product_6.fed9eefb.png";